import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { BookOpen, Gift, Sparkles } from "lucide-react";

export const JoinPage = () => {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (code && code.length >= 4 && code.length <= 24) {
      try { localStorage.setItem("lectura_ref", code); } catch { /* noop */ }
    }
  }, [code]);

  return (
    <div className="grain min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between bg-primary text-primary-foreground p-12 relative z-10">
        <div className="flex items-center gap-2.5">
          <span className="grid place-items-center h-9 w-9 rounded-xl bg-primary-foreground/15">
            <BookOpen className="h-5 w-5" />
          </span>
          <span className="font-serif text-2xl font-bold">Lectura<span className="text-accent">.</span></span>
        </div>
        <div>
          <h1 className="font-serif text-5xl font-bold leading-tight">A friend invited you.</h1>
          <p className="mt-4 text-lg opacity-80 max-w-md">
            Study smarter tonight — name any book, get a narrated lecture, a printable study guide, and a graded quiz.
          </p>
        </div>
        <p className="text-sm opacity-60">Study smarter. Score higher.</p>
      </div>

      <div className="flex items-center justify-center p-6 sm:p-12 relative z-10">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md text-center">
          <div className="mx-auto grid place-items-center h-16 w-16 rounded-2xl bg-accent/15 text-accent">
            <Gift className="h-8 w-8" />
          </div>
          <h2 className="mt-6 font-serif text-3xl sm:text-4xl font-bold">You've unlocked a gift 🎁</h2>
          <p className="mt-3 text-muted-foreground">
            When you sign up, we'll unlock <span className="font-semibold text-foreground">7 free lectures</span> — more than double the usual free trial. Your friend gets a month of Pro on us the moment you make your first lecture.
          </p>

          <ul className="mt-8 space-y-3 text-left text-sm">
            {[
              "7 free lectures (usually 3)",
              "AI-narrated audio + slides",
              "Printable study guides + graded quizzes",
              "Study in 27 languages",
            ].map((p) => (
              <li key={p} className="flex items-start gap-3">
                <Sparkles className="h-4 w-4 text-accent shrink-0 mt-0.5" />
                <span>{p}</span>
              </li>
            ))}
          </ul>

          <button
            data-testid="join-continue-btn"
            onClick={() => navigate("/register")}
            className="mt-8 w-full rounded-xl bg-accent text-accent-foreground py-3.5 font-semibold hover:opacity-90 transition"
          >
            Claim my 7 free lectures
          </button>
          <p className="mt-3 text-xs text-muted-foreground">
            Already have an account?{" "}
            <button onClick={() => navigate("/login")} className="font-semibold text-accent hover:underline">Sign in</button>
          </p>
        </motion.div>
      </div>
    </div>
  );
};
